import { Injectable } from '@angular/core';
import { SecureApi } from '../core/secure.api';

@Injectable()
export class ServiceProviderSettingService {
    constructor(public secureApi: SecureApi) { }

    read(url, id = 0) {
        return this.secureApi.get( url + '/read/' + id);
    }

    delete(url, item) {
        return this.secureApi.delete(url + '/delete/' + item['id'], false);
    }
}